import { z } from 'zod'

/**
 * A URL restricted to `http:`/`https:`.
 *
 * Zod 3.22's `.url()` accepts any URL-shaped string, including `javascript:`
 * and `data:` — both of which React 18 will happily render into an `href`,
 * making an unrestricted `.url()` field a stored-XSS vector wherever the
 * value later reaches a link.
 */
export const httpUrlSchema = z
  .string()
  .url()
  .refine(value => value.startsWith('http://') || value.startsWith('https://'), {
    message: 'URL must start with http:// or https://',
  })

/** Same check outside Zod, for gating a value that's already stored. */
export function isHttpUrl(value: string): boolean {
  return httpUrlSchema.safeParse(value).success
}
